import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const getDemoLink = async (body) =>
  swRequest({
    path: "/api/requests/get_demo_link",
    method: "POST",
    body,
  });
